module.exports = __webpack_public_path__ + "static/img/grain360.d9188d72.png";